import React, { useCallback } from 'react';
import check_icon from 'assests/svg/check_icon.svg';
import alert_warn from 'assests/svg/alert_warn.svg';
import alert_red from 'assests/svg/alert_red.svg';
import { LEAD_STATUS, TOAST_TYPE } from 'home/view/upgrade-order/constants';

import './index.scss';

const FeasibilityStatus = ({
  feasibilityStatus,
  media,
  leadStatus,
  createLead,
  pricingTag = false,
  isNonStandardHardware = false,
  isZeroRateCard = false,
  blockJourney = false,
  bwAtMaxCircuit = false,
  lowerPriceBw = false,
  isMediaOffnet = false,
  isMediaThirdParty = false,
  selectedPrimaryMedia = '',
  setToastMsg = () => {}
}) => {
  const renderStatus = useCallback(() => {
    const hasSelectedMedia = selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0;

    switch (leadStatus) {
      case LEAD_STATUS.FEASIBILITY_COMPLETED:
      case LEAD_STATUS.LEAD_SUBMITTED:
      case LEAD_STATUS.KYC_IN_PROGRESS:
      case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
      case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
        return (
          <div className="network_status network_status_success">
            <div className="stauts_icon">
              <img src={check_icon} alt="check" />
            </div>
            <div className="status_text">
              Network Availability Status with media type:{' '}
              {hasSelectedMedia ? (
                <strong>
                  Feasible ({selectedPrimaryMedia.key}) till {selectedPrimaryMedia.maxFeasibleBw} Mbps
                </strong>
              ) : (
                <strong>
                  Feasible ({media && media.value}) till {feasibilityStatus && feasibilityStatus.maxBandwidth} Mbps
                </strong>
              )}
            </div>
          </div>
        );
      }
      case LEAD_STATUS.FEASIBILITY_PENDING: {
        return (
          <div className="network_status network_status_pending">
            <div className="stauts_icon">
              <img src={alert_warn} alt="check" />
            </div>
            <div className="status_text">
              Network Availability Status with media type: <strong>Manual Network Check</strong> is underway to reconfirm network availability of this location. You will be
              notified in case of any additional CAPEX charges.{' '}
              {feasibilityStatus && feasibilityStatus.cbftTaskId
                ? `Your feasibility ID for
              this request is - ${feasibilityStatus && feasibilityStatus.cbftTaskId}`
                : ''}
            </div>
          </div>
        );
      }
      case LEAD_STATUS.LOCATION_NOT_FEASIBLE: {
        return (
          <div className="network_status network_status_error">
            <div className="stauts_icon">
              <img src={alert_red} alt="check" />
            </div>
            <div className="status_text">
              Network Availability Status with media type: <strong>Network is not feasible for {feasibilityStatus && feasibilityStatus.requestedBandwidth} Mbps. </strong>
              Please{' '}
              <span className="network_link" onClick={createLead}>
                create a new upgrade request
              </span>
              .
            </div>
          </div>
        );
      }
      default: {
        return null;
      }
    }
  }, [leadStatus, selectedPrimaryMedia]);

  const renderPricingStatus = useCallback(() => {
    const renderPreWarningComp = () => (
      <div className="network_status network_status_pending">
        <div className="stauts_icon">
          <img src={alert_warn} alt="warning" />
        </div>
        <div className="status_text">Your order will be assigned to KAM for pricing review. You will be alerted via email when the pricing is confirmed.</div>
      </div>
    );

    const renderWarningComp = () => (
      <div className="network_status network_status_pending">
        <div className="stauts_icon">
          <img src={alert_warn} alt="warning" />
        </div>
        <div className="status_text">Your order has been submitted to KAM for pricing review. You will be alerted via email when the pricing is confirmed.</div>
      </div>
    );

    switch (leadStatus) {
      case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
      case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
        // render notification
        const notificationMessage = (
          <span>
            <img
              src={alert_warn}
              alt="warning"
              style={{
                position: 'relative',
                top: 2
              }}
            />{' '}
            <b>Pricing Under Review</b>. Our account manager is actively working on your pricing request.
          </span>
        );

        setToastMsg(true, notificationMessage, TOAST_TYPE.WARNING);

        if (isNonStandardHardware || isZeroRateCard || lowerPriceBw) {
          return renderWarningComp();
        }

        return renderWarningComp();
      }
      case LEAD_STATUS.FEASIBILITY_COMPLETED: {
        if (isNonStandardHardware || isZeroRateCard || lowerPriceBw) {
          return renderPreWarningComp();
        }
        return null;
      }
      default: {
        return null;
      }
    }
  }, [leadStatus, lowerPriceBw]);

  if (blockJourney || bwAtMaxCircuit) {
    return (
      <div style={{ marginTop: 17 }}>
        <div className="network_status network_status_pending">
          <div className="stauts_icon">
            <img src={alert_warn} alt="check" />
          </div>
          <div className="status_text">
            Your circuit is running on the {''}
            <strong>highest available bandwidth</strong> for online upgrade.
            {isMediaOffnet && isMediaThirdParty ? '' : 'Please contact your KAM if any further upgrade is required.'}
          </div>
        </div>
      </div>
    );
  }

  return <div style={{ marginTop: 15 }}>{pricingTag ? renderPricingStatus() : renderStatus()}</div>;
};
export default FeasibilityStatus;
